import * as Sentry from '@sentry/react';

const appEnv = window.env.APP_ENV;
const dsn = window.env.SENTRY_DSN;

if (appEnv !== 'local' && dsn) {
  Sentry.init({
    dsn,
    environment: appEnv + ' - forms',
    ignoreErrors: [
      'dead code elimination has not been applied',
    ],
  });
}

export default Sentry;



// WEBPACK FOOTER //
// ./src/sentry.js